import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const FounderVisionSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const founderContent = content[language].founderVision;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="founder" 
      ref={sectionRef}
      className="section"
      style={{ background: 'var(--ivory)' }}
    >
      <div className="container-narrow">
        {/* Header */}
        <div className={`text-center mb-64 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2>{founderContent.title}</h2>
          <div className="divider" />
        </div>

        {/* Content */}
        <div 
          className={`fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{
            transitionDelay: '0.2s'
          }}
        >
          <div style={{
            fontSize: '1.0625rem',
            lineHeight: 1.9,
            color: 'var(--charcoal)',
            maxWidth: '900px',
            margin: '0 auto',
            whiteSpace: 'pre-line'
          }}>
            {founderContent.content}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderVisionSection;
